<template>
    <div>
        <div v-if="!isNaN(iconset)" class="w-100">
            <div
                class="w-100 p-0 cursor-pointer widget-overflow"
                :class="{ 'justify-content-around': session }"
                :style="selectedIconset === iconset ? 'border: solid 2px #d64571' : ''"
                @click="session ? null : $emit('select-iconset')"
            >
                <div class="d-flex py-1">
                    <div
                        v-for="(_, i) in iconsets[iconset]"
                        class="d-flex flex-column justify-content-center align-items-center text-white cursor-pointer position-relative mx-1"
                        :class="{ 'size-mini': mini, 'size-full': !mini }"
                        :style="{
                            backgroundColor: iconsets[iconset][i]
                                ? iconsets[iconset][i].color
                                : 'gray',
                            outline:
                                selectedPrompt === i ||
                                getIndexByValue(iconset, selectedValue) === i
                                    ? '2px solid #d64571'
                                    : '',
                            outlineOffset: '1px',
                            overflow: 'hidden',
                        }"
                        @click="
                            session ? $emit('select-prompt', [iconsets[iconset][i].value, i]) : null
                        "
                    >
                        <span class="" :class="{ 'prompt-logo-mini': mini, 'prompt-logo': !mini }">
                            <span v-if="iconsets[iconset][i].icon">
                                <i class="fa" :class="iconsets[iconset][i].icon"></i>
                            </span>
                            <span v-if="iconsets[iconset][i].letter">
                                <span>{{
                                    mini
                                        ? iconsets[iconset][i].letter.substr(0, 1)
                                        : iconsets[iconset][i].letter
                                }}</span>
                            </span>
                        </span>
                        <span v-if="!mini" class="prompt-description pb-2">
                            <div
                                :style="
                                    iconsets[iconset][i].description.length > 10
                                        ? 'text-align: center; font-size: 80%; line-height: 0.85;'
                                        : ''
                                "
                            >
                                {{ iconsets[iconset][i].description }}
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else="">
            <div
                v-if="value && value.length"
                :class="{
                    'size-mini d-flex align-items-center justify-content-center': mini,
                    'size-full': !mini,
                }"
                class="cursor-pointer"
                :style="{
                    backgroundColor: iconsets[value[0]][getIndexByValue(value[0], value[1])]
                        ? iconsets[value[0]][getIndexByValue(value[0], value[1])].color
                        : '#fff',
                }"
            >
                <div
                    class="d-flex flex-column justify-content-center align-items-center text-white"
                >
                    <span
                        class=""
                        :class="{ 'prompt-logo-mini': mini, 'prompt-logo': !mini }"
                        style="margin-top: -0.25rem;"
                    >
                        <span v-if="iconsets[value[0]][getIndexByValue(value[0], value[1])].icon">
                            <i
                                class="fa"
                                :class="
                                    iconsets[value[0]][getIndexByValue(value[0], value[1])].icon
                                "
                            ></i>
                        </span>
                        <span v-if="iconsets[value[0]][getIndexByValue(value[0], value[1])].letter">
                            <span>{{
                                mini
                                    ? iconsets[value[0]][
                                          getIndexByValue(value[0], value[1])
                                      ].letter.substr(0, 1)
                                    : iconsets[value[0]][getIndexByValue(value[0], value[1])].letter
                            }}</span>
                        </span>
                    </span>

                    <span v-if="!mini" class="prompt-description pb-2">
                        <span>{{
                            iconsets[value[0]][getIndexByValue(value[0], value[1])].description
                        }}</span>
                    </span>
                </div>
            </div>
            <div
                v-else=""
                :class="{
                    'size-mini d-flex align-items-center justify-content-center': mini,
                    'size-full': !mini,
                }"
                class="cursor-pointer"
                :style="{
                    backgroundColor: iconsets[prompt[0]][prompt[1]]
                        ? iconsets[prompt[0]][prompt[1]].color
                        : '#fff',
                }"
            >
                <div
                    class="d-flex flex-column justify-content-center align-items-center text-white"
                >
                    <span
                        class=""
                        :class="{ 'prompt-logo-mini': mini, 'prompt-logo': !mini }"
                        style="margin-top: -0.25rem;"
                    >
                        <span v-if="iconsets[prompt[0]][prompt[1]].icon">
                            <i class="fa" :class="iconsets[prompt[0]][prompt[1]].icon"></i>
                        </span>
                        <span v-if="iconsets[prompt[0]][prompt[1]].letter">
                            <span>{{
                                mini
                                    ? iconsets[prompt[0]][prompt[1]].letter.substr(0, 1)
                                    : iconsets[prompt[0]][prompt[1]].letter
                            }}</span>
                        </span>
                    </span>

                    <span v-if="!mini" class="prompt-description pb-2">
                        <span>{{ iconsets[prompt[0]][prompt[1]].description }}</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// This component can take an `iconset` parameter, in which, paired with `session == true`, it presents the list of icons in the iconset and emits `select-prompt` when one is chosen
// It can also take a `prompt`, with params [iconset, index] to display the icon by that index in the given iconset
// Or it can take a `value`, an array with [iconset, value] to fetch the given icon by its value
export default {
    name: "IntensityIcon",
    props: [
        "mini",
        "prompt",
        "iconset",
        "selectedIconset",
        "selectedPrompt",
        "selectedValue",
        "session",
        "value",
    ],
    data() {
        return {
            // We are using a 1-5 scale
            iconsets: [
                [
                    {
                        color: "#58dd55",
                        icon: null,
                        letter: "1",
                        description: "",
                        value: 1,
                    },
                    {
                        color: "#42e6c7",
                        icon: null,
                        letter: "2",
                        description: "",
                        value: 2,
                    },
                    {
                        color: "#f6d70c",
                        icon: null,
                        letter: "3",
                        description: "",
                        value: 3,
                    },
                    {
                        color: "#f99808",
                        icon: null,
                        letter: "4",
                        description: "",
                        value: 4,
                    },
                    {
                        color: "#d53e3f",
                        icon: null,
                        letter: "5",
                        description: "",
                        value: 5,
                    },
                ],
                [
                    {
                        color: "#f6d70c",
                        icon: null,
                        letter: "Low",
                        description: "",
                        value: 1,
                    },
                    {
                        color: "#f99808",
                        icon: null,
                        letter: "Med",
                        description: "",
                        value: 3,
                    },
                    {
                        color: "#d53e3f",
                        icon: null,
                        letter: "High",
                        description: "",
                        value: 5,
                    },
                ],
            ],
        };
    },
    methods: {
        getIndexByValue(iconset, value) {
            return this.iconsets[iconset].findIndex(icon => icon.value === value);
        },
    },
};
</script>

<style scoped lang="scss">
.prompt-logo {
    letter-spacing: -3px;
    font-size: 1.6rem;
}

.prompt-logo-mini {
    font-size: 0.8rem;
}

.prompt-description {
    margin-top: -0.5rem;
    font-size: 0.75rem;
}

.size-mini {
    max-width: 1.5rem;
    min-width: 1.5rem;
    max-height: 1.5rem;
    min-height: 1.5rem;
}

.size-full {
    max-width: 3rem;
    min-width: 3rem;
    max-height: 3rem;
    min-height: 3rem;
}

.widget-overflow {
    overflow-x: auto;
    overflow-y: hidden;
}
</style>
